// NEEC Digital logo lockups. Assets live in /public/logos.
export function Wordmark({ light = false, className = "", iconSize = 34 }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img src="/logos/icon.png" alt="NEEC Digital" width={iconSize} height={iconSize}
        style={{ height: iconSize, width: "auto" }} className="block" />
      <span className="font-display font-bold tracking-tight leading-none text-[1.35rem]">
        <span className={light ? "text-white" : "text-navy"}>NEEC</span>
        <span className="text-brand-blue"> DIGITAL</span>
      </span>
    </span>
  );
}

export function StackedLogo({ className = "" }) {
  return <img src="/logos/stacked.png" alt="NEEC Digital" className={className} />;
}

export function CircularBadge({ className = "" }) {
  return <img src="/logos/badge-circular.png" alt="NEEC Digital badge" className={className} />;
}
